import $ from 'jquery';
$(document).ready(function() {
    let page = $('#event_detail');
    if (page.length > 0) {

        let getTagOG = (name, content) => {
            var content = (content == null) ? 'content' : content;
            return document.querySelector("meta[property='" + name + "']").getAttribute(content);
        }
        let getTagName = (name, content) => {
            var content = (content == null) ? 'content' : content;
            return document.querySelector("meta[name='" + name + "']").getAttribute(content);
        }

        $(document).on('click', '.openInNewTab', function(event) {
            let url = $(this).data('url');
            openInNewTab(url);
        });

        function openInNewTab(url_code) {
            if (url_code && url_code != '') {
                window.open('https://www.s2.e-get.jp/kaat/pt/&s=' + url_code, 'getti', ' scrollbars=yes,width=850,height=600,resizable=1,left=10,top=10');
            } else {
                window.open('https://www.s2.e-get.jp/kaat/pt/', 'getti', ' scrollbars=yes,width=850,height=600,resizable=1,left=10,top=10');
            }
        };

        function fbShare(url, title, descr, image) {
            window.open('http://www.facebook.com/sharer.php?s=100&p[title]=' + title + '&p[summary]=' + descr + '&p[url]=' + url + '&p[images][0]=' + image, 'sharer', 'top=20,left=20,toolbar=0,status=0,width=600,height=300,resizable=1');
        }

        function openFbPopUp() {
            fbShare(encodeURIComponent(getTagOG('og:url')), getTagOG('og:title'), getTagOG('og:description'), getTagOG('og:image'));
            return false;
        }

        function openTwPopUp() {
            window.open(`https://twitter.com/intent/tweet?url=${encodeURIComponent(window.location.href)}&text=${getTagName('twitter:title')}`, 'twitterwindow', 'left=20,top=20,width=600,height=300,toolbar=0,resizable=1');
            return false;
        }
        $(document).on('click', '.share-network-facebook', function() {
            openFbPopUp();
        });
        $(document).on('click', '.share-network-twitter', function() {
            openTwPopUp();
        });
        const dataJsonLd = $("#dataJsonLd");
        const getJsonld = () => {
            return {
                "@context": "https://schema.org",
                "@type": "Event",
                "name": dataJsonLd.data('title'),
                "startDate": dataJsonLd.data('start-date'),
                "endDate": dataJsonLd.data('end-date'),
                "eventAttendanceMode": "https://schema.org/OfflineEventAttendanceMode",
                "eventStatus": "https://schema.org/EventScheduled",
                "location": {
                    "@type": "Place",
                    "name": dataJsonLd.data('place'),
                    "address": {
                        "@type": "PostalAddress",
                        "streetAddress": "〒231-0023 神奈川県横浜市中区山下町281"
                    }
                },
                "image": $('.swiper-wrapper').data('image'),
                "description": dataJsonLd.data('overview'),
                "performer": {
                    "@type": "PerformingGroup",
                    "name": dataJsonLd.data('registrant')
                },
                "organizer": {
                    "@type": "Organization",
                    "name": dataJsonLd.data('organizer-name'),
                    "url": dataJsonLd.data('organizer-url')
                }
            };
        }
        $('script[type="application/ld+json"]')[0].textContent = JSON.stringify(getJsonld(), null, "\t");

        const listNews = $('.listNews li');
        $(document).on('click', '.showMoreInformation', function() {
            listNews.removeClass('noDisplay');
        });
    }
});
